import { FC, useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'common-components';
import styles from './categoryBanner.module.scss';

const CategoryBanner: FC<CategoryBannerProps> = (props: CategoryBannerProps) => {
    const { id, iconUrl, displayName, isSelected, onEdit, onSelect } = props;

    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className={classNames(styles.container, isSelected && styles['selected-container'])}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
                onSelect && onSelect(displayName);
            }}
        >
            <div className={styles['background-image-wrapper']} style={{ backgroundImage: `url(${iconUrl})` }} />
            <span className={styles.header}>{displayName}</span>
            {isHovered && onEdit && (
                <div className={styles['edit-container']} onClick={() => onEdit(id)}>
                    <Icon name="editAdmin" style={{ display: 'flex', width: '1.2rem' }} />
                </div>
            )}
        </div>
    );
};

interface CategoryBannerProps {
    id: number;
    iconUrl: string;
    displayName: string;
    isSelected: boolean;
    onEdit?: (id: number) => void;
    onSelect?: (displayName: string) => void;
}

export default CategoryBanner;
